import { render, staticRenderFns } from "./MatrixBlockLandingPageContent.vue?vue&type=template&id=8dc98a1c"
import script from "./MatrixBlockLandingPageContent.vue?vue&type=script&lang=js"
export * from "./MatrixBlockLandingPageContent.vue?vue&type=script&lang=js"
import style0 from "./MatrixBlockLandingPageContent.vue?vue&type=style&index=0&id=8dc98a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports